// Data for the three Offsite Digital media feature sections, rendered by
// <MediaFeatureSection>. Asset URLs must be static `url:` imports (Parcel
// content-hashes each format), so the asset wiring lives here in JS while the
// copy/config below stays declarative.

import React from 'react';
import poweredByAvif from 'url:../../assets-optimized/redesign/solutions/offsite-digital/poweredBy.avif';
import poweredByWebp from 'url:../../assets-optimized/redesign/solutions/offsite-digital/poweredBy.webp';
import poweredByPng from 'url:../../assets-optimized/redesign/solutions/offsite-digital/poweredBy.png';
import poweredByMobileAvif from 'url:../../assets-optimized/redesign/solutions/offsite-digital/poweredBy_mobile.avif';
import poweredByMobileWebp from 'url:../../assets-optimized/redesign/solutions/offsite-digital/poweredBy_mobile.webp';
import poweredByMobilePng from 'url:../../assets-optimized/redesign/solutions/offsite-digital/poweredBy_mobile.png';
import highIntentWebm from 'url:../../assets-optimized/redesign/solutions/offsite-digital/high-intent.webm';
import highIntentMp4 from 'url:../../assets-optimized/redesign/solutions/offsite-digital/high-intent-1.mp4';
import meetTravelersWebm from 'url:../../assets-optimized/redesign/solutions/offsite-digital/meet-travelers.webm';
import meetTravelersMp4 from 'url:../../assets-optimized/redesign/solutions/offsite-digital/meet-travelers-1.mp4';

const offsiteDigitalSections = [
  {
    id: 'powered-by',
    variant: 'light',
    background: { type: 'image', avif: poweredByAvif, webp: poweredByWebp, fallback: poweredByPng },
    backgroundMobile: { avif: poweredByMobileAvif, webp: poweredByMobileWebp, fallback: poweredByMobilePng },
    title: 'POWERED BY',
    description: [
      'Engage travelers with sight, sound, ',
      'and motion before and during key choices',
      'being made by travelers.'
    ],
    card: {
      heading: 'PROGRAMMATIC DISPLAY',
      text: 'Campaigns continuously improve to maximize performance across the traveler journey.',
      maxWidth: 357,
    },
    cardPlacement: 'left',
    cornerText: 'TRAVELER DATA',
  },
  {
    id: 'high-intent',
    variant: 'light',
    background: {
      type: 'video',
      webm: highIntentWebm,
      mp4: highIntentMp4,
      position: '14% 60%',
      zoom: 1.3,
      // Desktop framing pushes the laptop off-screen on tall/narrow viewports;
      // recenter and ease the zoom so the laptop stays visible on mobile.
      positionMobile: '39% 100%',
      zoomMobile: 1.1,
    },
    title: <span className="no-wrap">HIGH-INTENT</span>,
    description: [
      'Engage travelers with sight, sound, ',
      'and motion before and during key choices',
      'being made by travelers.'
    ],

    card: {
      highlight: '66%',
      heading: 'HIGHLY LIKELY',
      text: 'to have taken ​action after watching a video ​in the last 12 months (clicked on an advertisement or links or made a purchase)​',
      maxWidth: 438,
    },
    cardPlacement: 'left',
    cornerText: 'VIEWERS',
  },
  {
    id: 'meet-travelers',
    variant: 'dark',
    background: { type: 'video', webm: meetTravelersWebm, mp4: meetTravelersMp4, position: '50% 0%', zoom: 1 },
    title: <span className="no-wrap">MEET TRAVELERS</span>,
    description: [
      'From upper-funnel discovery to conversion-driven',
      'retargeting, we help your brand influence travelers',
      'beyond Marriott — meeting them on the platforms',
      'they use every day.',
    ],
    descriptionMobile: [
      'From upper-funnel discovery to',
      'conversion-driven retargeting, we help',
      'your brand influence travelers beyond',
      'Marriott — meeting them on the',
      'platforms they use every day.',
    ],
    card: {
      highlight: '47%',
      heading: 'HIGHLY LIKELY',
      text: 'to have made 6 or more purchases by clicking on a social media ad in the last 12 months',
      maxWidth: 438,
    },
    cardPlacement: 'left',
    cornerText: 'WHEN SOCIAL',
  },
];

export default offsiteDigitalSections;
